import { CreateTripItemData } from 'tripPlanner/api/tripItem/types'
import { TripItem } from 'tripPlanner/types/tripItem'
import { assertUnreachable } from 'tripPlanner/utils'
import {
  nullBookedDetails,
  nullEndDates,
  nullStartDates,
} from 'tripPlanner/utils/nullify'

export function itemToPublicTripItemPayload(
  tripItem: TripItem,
): CreateTripItemData {
  const {
    id: templateItemId,
    tripId: templateId,
    createdBy,
    updatedBy,
    createdAt,
    updatedAt,
    ...item
  } = tripItem

  switch (item.type) {
    case 'RESTAURANT_BAR':
    case 'ATTRACTION':
      return {
        ...item,
        ...nullStartDates,
        ...nullBookedDetails,
      }
    case 'EVENT':
    case 'EXPERIENCE':
    case 'ACCOMMODATION':
    case 'BUS':
    case 'FERRY':
    case 'OTHER_TRANSPORT':
    case 'TRAIN':
    case 'THING_TO_DO':
    case 'FLIGHT':
    case 'CAR_RENTAL':
    case 'CRUISE':
    case 'TOUR':
      return {
        ...item,
        ...nullStartDates,
        ...nullEndDates,
        ...nullBookedDetails,
      }
    case 'NOTE':
      return {
        ...item,
        ...nullStartDates,
        ...nullEndDates,
        ...nullBookedDetails,
        isSectionHeader: !!item.isSectionHeader,
      }
    default:
      return assertUnreachable(item)
  }
}
